import React, { memo } from "react";
import { BackButton } from "components/buttons";
import { RGLogo } from "components/UI/RGLogo";
import { useMediaQuery } from "usehooks-ts";
import { TABLET_WIDTH } from "hooks/useDeviceType";
import { ReactComponent as ArrowLeftIcon } from "components/icons/arrowLeftAdornment.svg";
import "./FullScreenNav.scss";

interface IFullscreenNavProps {
  toggleFullScreen: () => void;
}

export const FullScreenNav: React.FC<IFullscreenNavProps> = memo(({
  toggleFullScreen
}) => {
  const isDesktop = useMediaQuery(`(min-width: ${TABLET_WIDTH}px)`);

  return (
    <div className="FullscreenNav">
      {isDesktop ? (
        <>
          <BackButton onClick={toggleFullScreen} />
          {<RGLogo />}
        </>
      ) : (
        <button className="FullscreenNav-MobileButton" onClick={toggleFullScreen}>
          <ArrowLeftIcon />
        </button>
      )}
    </div>
  );
});
